import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { ReqMethods, ghl } from "../../enums";
import env from "../../config/env";
import { useAppServices } from "../../hook/services";
import img from "../../assets/Images/mainImage.png"
import "./style.css"

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const account_id = new URLSearchParams(search).get("state");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const associate = async (creds) => {
    var payload = {
      _id: account_id,
      ghl: {
        location_id: creds.locationId,
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };

    const { response } = await AppServices.accounts.update({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");
    // update(payload);
    return setError("Location Connect Successfully");
  };

  const getLocation = async (creds) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.location(creds.locationId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");

    return response && associate(response.data, creds) && setError("Location SuccessFully connected");
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env?.GHL?.ACCOUNT_CLIENT_ID,
        client_secret: env?.GHL?.ACCOUNT_CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
    return response && associate(response.data);
  };

  const onLoad = () => {
    env?.GHL?.Location_CLIENT_ID && getCreds();
  };

  useEffect(onLoad, []);

  return (
    <div className="container">
      <img
        src={img}
        alt="bilal"
        className="image"
      />

      {!Error &&
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      }

      {Error && (
        <div>
          <p>
            {Error}
          </p>

          <div className="error">
            <button className="button" onClick={() => navigate(-2)} >
              Go Back
            </button>
          </div>

        </div>
      )}
    </div>
  );
}

export default GHL;
